import {
  backToDpdSiteHeader,
  backToDpdSiteSpeedDeal,
  getDpdAppHeader,
  goBackToDeliveryDetailsSpeedDeal,
  goToParcelInfoHeader,
  goToParcelInfoSpeedDeal,
  trackAnotherParcelHeader,
} from '../controlActions';

export const createHeaderControlActions = props => [
  goToParcelInfoHeader(props),
  trackAnotherParcelHeader(props),
  backToDpdSiteHeader(props),
  getDpdAppHeader(props),
];

export const createRatingSpeedDealControlActions = props => [
  backToDpdSiteSpeedDeal(props),
  goBackToDeliveryDetailsSpeedDeal(props),
  goToParcelInfoSpeedDeal(props),
];
